<template>
  <div
    class="d-flex p-4 shadow-sm rounded-lg align-content-center flex-column justify-content-center"
    :class="
      computedIsActiveStyle ? 'text-white bg-' + types[type].color : 'bg-white'
    "
  >
    <Loading v-if="isInitialLoading" :type="1" />
    <div v-else>
      <div
        class="d-flex align-items-center justify-content-between status-header"
      >
        <span v-if="!isLoading">{{ softwareCount }}</span>
        <div v-else class="container-spinner">
          <b-spinner
            variant="light"
            label="Spinning"
            style="font-size: 16px;"
            :class="computedIsActiveStyle ? 'text-white' : ''"
          ></b-spinner>
        </div>
        <i
          class="icon status-icon mb-2"
          :class="
            computedIsActiveStyle
              ? types[type].icon + ' text-white'
              : types[type].icon + ' text-' + types[type].color
          "
        ></i>
      </div>
      <p>{{ types[type].text }}</p>
    </div>
  </div>
</template>
<script>
import Loading from "./Loading.vue";
/**
 * @description Composante gérant les notifications de logiciels en état particulier
 * @author Samuel Colassin
 * @author Samuel Dubé
 * @author Alexandre Gallant
 * @vue-prop {Number} softwareCount - Valeur à afficher
 * @vue-prop {String} type - Type que le composant doit prendre
 * @vue-prop {Boolean} isLoading - Si le composant doit indiquer à l'utilisateur qu'il est en cours de chargement
 * @vue-data {Object} types - Les valeurs à utiliser selon le type demandé
 * @vue-data {Boolean} isInitialLoading - Si le chargement initial est en cours
 * @vue-computed {Boolean} computedIsActiveStyle - Si le style doit être appliqué
 */
export default {
  components: {
    Loading
  },
  props: {
    softwareCount: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    /**
     * @description Détermine si «isInitialLoading» doit être mis à faux selon le paramètre donné
     * @param {Boolean} newValue La nouvelle valeur de «isLoading»
     */
    isLoading: function(newValue) {
      if (!newValue) {
        this.isInitialLoading = false;
      }
    }
  },
  data() {
    return {
      types: {
        critical: {
          text: this.$i18n.t(
            "sections.simplifiedStatisticsCardSection.types.critical.text"
          ),
          color: "danger",
          icon: "exclamation triangle"
        },
        warning: {
          text: this.$i18n.t(
            "sections.simplifiedStatisticsCardSection.types.warning.text"
          ),
          color: "warning",
          icon: "exclamation circle"
        },
        alive: {
          text: this.$i18n.t(
            "sections.simplifiedStatisticsCardSection.types.alive.text"
          ),
          color: "success",
          icon: "check circle"
        }
      },
      isInitialLoading: true
    };
  },
  computed: {
    computedIsActiveStyle() {
      return (
        this.softwareCount !== 0 &&
        this.type !== "alive" &&
        !this.isInitialLoading
      );
    }
  }
};
</script>
<style scoped lang="scss">
.status-header {
  font-size: 2em;
}
.status-icon {
  font-size: 0.8em !important;
}
.container-spinner {
  width: 48px;
  height: 48px;
}
</style>
